import React from "react";

const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

// localhost pe relative path (setupProxy.js handle karta hai)
// production pe direct km2.amnex.co.in ka URL use hoga
const KM2_URL = isLocalhost
  ? "/km2/index.html"
  : "https://km2.amnex.co.in";

const containerStyle = {
  width: "100%",
  minHeight: "100vh",
  height: "100dvh",
  margin: 0,
  padding: 0,
  overflow: "hidden",
};

const iframeStyle = {
  display: "block",
  width: "100%",
  height: "100%",
  border: "none",
};

const Km2 = () => {
  return (
    <div style={containerStyle}>
      <iframe
        src={KM2_URL}
        style={iframeStyle}
        title="Krishi Mapper 2.0"
        allowFullScreen
      />
    </div>
  );
};

export default Km2;
